export default "__VITE_ASSET__5f7bfc60__"